export default function (parent, newChild) {
	if (parent.firstChild) {
		parent.insertBefore(newChild, parent.firstChild);
	}
	else {
		parent.appendChild(newChild);
	}
}


// WEBPACK FOOTER //
// ./js/utilities/prepend/u-prepend.js